import { cn } from '@/lib/utils';

interface PageContainerProps {
    children: React.ReactNode;
    className?: string;
    /** Kept for API compatibility; all pages now share one width */
    isDashboard?: boolean;
}

export const PageContainer = ({ children, className }: PageContainerProps) => {
    return (
        <main id="main" className={cn('flex-1 overflow-y-auto', className)}>
            <div className="mx-auto w-full max-w-[90rem] space-y-6 px-4 py-6 md:space-y-8 md:px-6 md:py-8 lg:px-8 animate-in fade-in-0 duration-300">
                {children}
            </div>
        </main>
    );
};
